import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { ASCTools } from '@alife/workstation-utils';
import { useCreation, useMemoizedFn } from 'ahooks';
import { createFetchMcms, getHoursTime } from "./service";
export function useMcms(options, defaultLocale) {
  var overWriteLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _ref = options || {},
    appName = _ref.appName,
    lang = _ref.lang,
    version = _ref.version,
    tag = _ref.tag,
    timeout = _ref.timeout;
  var _useState = useState(_objectSpread(_objectSpread({}, defaultLocale), overWriteLocale) || {}),
    _useState2 = _slicedToArray(_useState, 2),
    locale = _useState2[0],
    setLocale = _useState2[1];
  var fetchMcms = useCreation(function () {
    return createFetchMcms({
      timeout: timeout !== null && timeout !== void 0 ? timeout : version ? -1 : getHoursTime(24)
    });
  }, [timeout]);
  var setMcms = useMemoizedFn( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchMcms(data);
          case 3:
            result = _context.sent;
            setLocale(_objectSpread(_objectSpread(_objectSpread({}, locale), ASCTools.getMcmsLocale(result, lang)), overWriteLocale));
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0.message);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
  useEffect(function () {
    if (appName) {
      setMcms({
        appName: appName,
        tag: tag,
        version: version
      });
    }
  }, [appName, version, tag]);
  Object.assign(locale, overWriteLocale);
  return [locale, setMcms];
}
export function connectMcms(options) {
  return function (Component) {
    var defaultLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function McmsHoc(props) {
      var _useMcms = useMcms(options, defaultLocale, props.locale),
        _useMcms2 = _slicedToArray(_useMcms, 1),
        locale = _useMcms2[0];
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        locale: locale
      }));
    };
  };
}
export default useMcms;